import { render, staticRenderFns } from "./LandingCarouselBar.vue?vue&type=template&id=53c5634a&"
import script from "./LandingCarouselBar.vue?vue&type=script&lang=js&"
export * from "./LandingCarouselBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports